/* eslint-disable */
import { useContext, useEffect } from "react";

import { useNavigate } from "react-router-dom";

import { useGetCustomerDetailsQuery, useUpdateAcquisitionStatusMutation } from "../../store/userSlice";
import { AddressForm } from "../../components/AddressLocation";
import { LocalizationContext } from "../../App";
import { AtIcon, IconPhone } from "../../common/icons";
import { UpdateAcquisitionStatusRequest } from "../../models/request/UpdateAcquisitionStatusRequest";

const ActivateAccount = () => {
  const { data: profile, isLoading: isProfileLoading } = useGetCustomerDetailsQuery();
  const l10n = useContext(LocalizationContext);
  const navigate = useNavigate();
  const [
    updateAcquisitionStatus,
    { isLoading: isUpdatingAcquisitionStatus, isSuccess: isAcquisitionStatusUpdateSuccess },
  ] = useUpdateAcquisitionStatusMutation();

  useEffect(() => {
    if (profile?.acquisitionStatus || isAcquisitionStatusUpdateSuccess) navigate("/");
  }, [profile, isAcquisitionStatusUpdateSuccess]);

  const handleConfirm = () => {
    if (profile) {
      updateAcquisitionStatus(new UpdateAcquisitionStatusRequest());
    }
  };

  if (isProfileLoading)
    return (
      <div className="loading-screen flex flex-col justify-center items-center">
        <div className="text-body text-xl">{l10n.common.loading}</div>
      </div>
    );

  if (!profile) return <>Oops, no data!</>;

  return (
    <>
      <h2>
        {l10n.title.welcome}
        {profile.fullName && (
          <>
            <span>,{" "}</span>
            <span className="font-semibold">{profile.fullName}</span>
          </>
        )}
      </h2>
      <p className="mb-4">{l10n.notice.pleaseCheckPersonalInformation}</p>

      <div className="card">
        <div className="card-body flex flex-col gap-3">
          <AddressForm
            isPreviewMode={true}
            inputAddressData={profile.locationAddress}
            onChange={() => {}}
          />
          <div className="flex items-center gap-4">
            <IconPhone className={"w-5 h-5 stroke-2 stroke-card"} />
            <span className="text-card">{profile.phone.replace(/\s/g, "")}</span>
          </div>
          <div className="flex items-center gap-4">
            <AtIcon className={"w-5 h-5 stroke-2 fill-card"} />
            <span className="text-card">{profile.email}</span>
          </div>
        </div>
      </div>

      <button
        disabled={isUpdatingAcquisitionStatus}
        onClick={handleConfirm}
        className="btn btn-primary"
      >
        {isUpdatingAcquisitionStatus
          ? l10n.common.loading
          : l10n.btn.confirmDetails}
      </button>

      <p className="mt-6">
        <span>{l10n.notice.ifInformationIsIncorrectPleaseContactRm}</span>
      </p>
      <button className="btn btn-secondary" onClick={() => navigate("/broker")}>
        {l10n.menu.contactRM}
      </button>
    </>
  );
};

export default ActivateAccount;
